import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProviderPage = lazy(() => import('../views/list/ProviderPage'));

export function ProviderPageLazy() {
	return (
		<PageSuspense>
			<ProviderPage />
		</PageSuspense>
	);
}
